import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import BookOpenIcon from "components/Icons/BookOpenIcon";
import HelpIcon from "components/Icons/HelpIcon";
import { SecondaryItem, StyledLink } from "..";
import useSidebar from "../../SidebarProvider/useSidebar";
import { useTranslation } from "react-i18next";
import TooltipHelper from "components/TooltipHelper";
import Typography from "components/Typography";

function SidebarSecondaryContent() {
  const { t } = useTranslation();
  const { open } = useSidebar();

  return (
    <List
      data-sidebar="group"
      sx={{
        display: "flex",
        flexDirection: "column",
        padding: "0 8px",
        gap: "4px",
        marginTop: "auto",
      }}
    >
      <TooltipHelper placement="right" title={open ? null : t("global.resources_label")}>
        <ListItem disablePadding sx={{ width: "100%" }}>
          <StyledLink
            to="https://help.outputsports.com/en/"
            target="_blank"
            rel="noopener noreferrer"
            sx={{ width: "100%" }}
            aria-label={t("global.resources_label")}
          >
            <SecondaryItem>
              <BookOpenIcon htmlColor="grey.60" sx={{ fontSize: "20px" }} />
              {open ? (
                <Typography variant="TextS" noWrap>
                  {t("global.resources_label")}
                </Typography>
              ) : null}
            </SecondaryItem>
          </StyledLink>
        </ListItem>
      </TooltipHelper>
      <TooltipHelper placement="right" title={open ? null : t("global.support_label")}>
        <ListItem disablePadding aria-label={t("global.support_label")}>
          <SecondaryItem id="intercom-launcher" tabIndex={0}>
            <HelpIcon sx={{ fontSize: "20px" }} htmlColor="grey.60" />
            {open ? (
              <Typography variant="TextS" noWrap>
                {t("global.support_label")}
              </Typography>
            ) : null}
          </SecondaryItem>
        </ListItem>
      </TooltipHelper>
    </List>
  );
}

export default SidebarSecondaryContent;
